import { createSlotRecipe } from './runtime.js';

const resizableConfig = {"name":"resizable","slots":["panelGroup","panel","handle","handleIcon"],"defaultVariants":{"direction":"horizontal"},"variantMap":{"direction":["horizontal","vertical"]}}

export const resizable = /* @__PURE__ */ createSlotRecipe(resizableConfig)